import type {HostMap} from '../../../types'

export const UNSTABLE = {
  account: 'delivery-frontend-account.taxi.dev.yandex.net',
  auth: 'delivery-frontend-auth.taxi.dev.yandex.net',
  order: 'delivery-frontend-order.taxi.dev.yandex.net',
  route: 'delivery-frontend-route.taxi.dev.yandex.net',
} as const satisfies HostMap
